import React from 'react'



const NotificationsPage = () => {
    return ( 
        <>
        <p>Coming soon</p>
        </>
     );
}
 
export default NotificationsPage;